import apiLogo from '../../images/themes/api_logo_desktop.png';
import defaultLogo from '../../images/logo_desktop.png';

export default {
    apitravel: {
        main: '#447D7F',
        heading: '#1E264C',
        active: '#009999',
        logo: apiLogo,
    },
    default: {
        main: '#006845',
        heading: '#006845',
        active: '#2d825a',
        logo: defaultLogo,
    },
};



// WEBPACK FOOTER //
// ./src/app/constants/themes.js